<template>
    <div>

        <GChart  :type="type" :data="data" :options="options" :settings="settings" />
     
    </div>
    
  </template>
  
  <script>
  import { GChart } from 'vue-google-charts/legacy';
  
  export default {
    name: 'TimelineChart',
    components: {
      GChart,
    },
    props:{
        rows: Array,
        columns: Array, 
    },
    data() {
      return {
        type: "Timeline",
        data: [],
        // rows: [],
        // columns: [],
        options: {
            width: 1500,
            height: 620,
            
            avoidOverlappingGridLines: false,
            colors: ["#d64646","#4bb678" ], // Assign green for "Ready" and red for "Not ready",
            timeline: {
              rowLabelStyle: {
                  fontSize: 14,
                  // color: '#603913',
              },
              showBarLabels:false
            // barLabelStyle: {
            //     fontSize: 14,
            // },
            },
            hAxis: {
                format: 'HH:mm', // Format the time axis to show hours and minutes
                minorGridlines: {
                    count: 24, // Set minor gridlines to divide the day into 24 hours
                },
                // minValue: new Date("2024-05-20T00:00:00.000+07:00"),
                // maxValue: new Date("2024-05-20T23:59:59.999+07:00")
            },
        },
        settings: {
          packages: ['timeline'],
        },
      };
    },
    
    mounted(){
        // console.log(this.rows)
        // console.log(this.columns)
        // const columns = [
        // { type: "string", id: "agent" },
        // { type: "string", id: "status" },
        // { type: "date", id: "Start" },
        // { type: "date", id: "End" },
        // ];

        // const rows = [
        // ["Agent1@fpt.com", "Ready", new Date ("2024-05-20T00:00:00.567+07:00"), new Date ("2024-05-20T04:12:34.567+07:00")],
        // ["Agent1@fpt.com", "Not ready", new Date ("2024-05-20T04:12:34.567+07:00"), new Date ("2024-05-20T06:12:34.567+07:00")],
        // ["Agent1@fpt.com", "Ready", new Date ("2024-05-20T06:12:34.567+07:00"), new Date ("2024-05-20T23:59:59.999+07:00")],
        // ["Agent2@fpt.com", "Ready", new Date ("2024-05-20T00:00:00.567+07:00"), new Date ("2024-05-20T04:12:34.567+07:00")],
        // ["Agent2@fpt.com", "Not ready", new Date ("2024-05-20T04:12:34.567+07:00"), new Date ("2024-05-20T10:12:34.567+07:00")],
        // ["Agent2@fpt.com", "Ready", new Date ("2024-05-20T10:12:34.567+07:00"), new Date ("2024-05-20T13:12:34.567+07:00")],
        // ["Agent2@fpt.com", "Not ready", new Date ("2024-05-20T13:12:34.567+07:00"), new Date ("2024-05-20T23:59:59.999+07:00")],
        // ["Agent3@fpt.com", "Not ready", new Date ("2024-05-20T00:00:00.567+07:00"), new Date ("2024-05-20T07:12:34.567+07:00")],
        // ["Agent3@fpt.com", "Ready", new Date ("2024-05-20T07:12:34.567+07:00"), new Date ("2024-05-20T09:12:34.567+07:00")],
        // ["Agent3@fpt.com", "Not ready", new Date ("2024-05-20T09:12:34.567+07:00"), new Date ("2024-05-20T13:12:34.567+07:00")],
        // ["Agent3@fpt.com", "Ready", new Date ("2024-05-20T13:12:34.567+07:00"), new Date ("2024-05-20T23:59:59.999+07:00")],
        // ["Agent4@fpt.com", "Ready", new Date ("2024-05-20T00:00:00.000+07:00"), new Date ("2024-05-20T23:59:59.999+07:00")],
        // ["Agent5@fpt.com", "Ready", new Date ("2024-05-20T00:00:00.000+07:00"), new Date ("2024-05-20T17:59:59.999+07:00")],
        // ["Agent5@fpt.com", "Not ready", new Date ("2024-05-20T17:59:59.999+07:00"), new Date ("2024-05-20T23:59:59.999+07:00")],
        // ["Agent6@fpt.com", "Ready", new Date ("2024-05-20T00:00:00.000+07:00"), new Date ("2024-05-20T13:09:59.999+07:00")],
        // ["Agent6@fpt.com", "Not ready", new Date ("2024-05-20T13:09:59.999+07:00"), new Date ("2024-05-20T23:59:59.999+07:00")],
        // ["Agent7@fpt.com", "Ready", new Date ("2024-05-20T00:00:00.000+07:00"), new Date ("2024-05-20T23:59:59.999+07:00")],
        // ["Agent8@fpt.com", "Ready", new Date ("2024-05-20T00:00:00.000+07:00"), new Date ("2024-05-20T23:59:59.999+07:00")],
        // ["Agent9@fpt.com", "Ready", new Date ("2024-05-20T00:00:00.000+07:00"), new Date ("2024-05-20T23:59:59.999+07:00")],
        // ["Agent10@fpt.com", "Not ready", new Date ("2024-05-20T00:00:00.000+07:00"), new Date ("2024-05-20T08:59:59.999+07:00")],
        // ["Agent10@fpt.com", "Ready", new Date ("2024-05-20T08:59:59.999+07:00"), new Date ("2024-05-20T17:59:59.999+07:00")],
        // ["Agent10@fpt.com", "Not ready", new Date ("2024-05-20T17:59:59.999+07:00"), new Date ("2024-05-20T23:59:59.999+07:00")],

    
    // ];
        let chartData = [this.columns, ...this.rows];
        this.data = chartData
        console.log(this.data[1][1]==='ready')
        if (this.data[1][1]==='ready'){
            this.options.colors = ["#4bb678","#d64646" ]
        }else{
            this.options.colors = ["#d64646","#4bb678" ]
        }
    },
    methods:{
        getRandomTimeToday() {
            const today = new Date();
            today.setHours(0, 0, 0, 0); // Đặt thời gian về đầu ngày

            const randomTime = new Date(today.getTime() + Math.random() * (24 * 60 * 60 * 1000)); // Thêm thời gian ngẫu nhiên trong ngày

            return randomTime; // Chuyển đổi thời gian thành chuỗi ISO
        },
        calculateTotals(rows) {
            const totals = {};

            rows.forEach(row => {
                const [agent, status, start, end] = row;
                const duration = (new Date(end) - new Date(start)) / (1000 * 60 * 60); // duration in hours

                if (!totals[agent]) {
                totals[agent] = { ready: 0, notReady: 0 };
                }

                if (status === "Ready") {
                totals[agent].ready += duration;
                } else if (status === "Not ready") {
                totals[agent].notReady += duration;
                }
            });

            return totals;
            },
            
        formatDuration(hours) {
            const h = Math.floor(hours);
            const m = Math.floor((hours - h) * 60);
            return `${h}h ${m}m`;
        },

    },
    watch:{
        data(){
            if (this.data[1][1]==='ready'){
                this.options.colors = ["#4bb678","#d64646" ]
            }else{
                this.options.colors = ["#d64646","#4bb678" ]
            }
        }
    }
  };
  </script>
  
<style>
.custom-pagination {

  --v-pagination-item-margin: 5px;
  --v-pagination-border-radius: 50%;
  --v-pagination-background-color: rgba(255, 255, 255, 0); /* Fully transparent background color */
  --v-pagination-active-color: #ffffff; /* Active text color */
}

.custom-pagination .v-pagination__item {
  border: 2px solid var(--v-pagination-color);
  transition: background-color 0.3s, color 0.3s;
}

.custom-pagination .v-pagination__item--active {
  color: var(--v-pagination-active-color);
  background-color: var(--v-pagination-active-background-color);
}

.custom-pagination .v-pagination__item:hover {
  background-color: var(--v-pagination-color);
  color: var(--v-pagination-active-color);
}

.custom-pagination .v-pagination__more {
  color: var(--v-pagination-color);
}

.custom-pagination .v-pagination__more:hover {
  background-color: var(--v-pagination-color);
  color: var(--v-pagination-active-color);
}
</style>